'use strict'

/**
 * Mixin para validar captcha
 *
 * @author Valentin Agudelo Aquite
 * @version 1.0.0
 * @since 04/03/2020 09:13 AM
 */
const recaptchaV3Mixin = {
  methods: {
    /**
     * Persist user information.
     *
     * @author C Camilo Castellanos
     * @version 1.0.0
     * @since 19/12/2019 11:42 p. m.
     */
    $_recaptchaV3Mixin_validate () {
      let recaptcha = new Promise((resolve) => {
        window.grecaptcha.ready(async () => {
          const token = await window.grecaptcha.execute(process.env.VUE_APP_RECAPTCHA_SITE_KEY, { action: 'homepage' })
          resolve(token)
        })
      })
      return recaptcha.then(token => {
        return this.axios.post(`${process.env.VUE_APP_API_URL}seguridad/validar-recaptcha/`, {
          response: token
        }).then(response => {
          return response.data.success
        }).catch(() => {
          return false
        })
      }).catch(() => {
        return false
      })
    }
  }
}

export default recaptchaV3Mixin
